var map = {
	"./scb/components/OrderDialog/OrderCancel": 36231,
	"./ttl/components/OrderDialog/OrderCancel": 77939
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 95124;
module.exports = webpackAsyncContext;